import { useTranslation } from '@gimlite/common';
import { Form, FormType, WizardItemType, Zone } from '@gimlite/ui-v1';
import { DateTime } from 'luxon';
import { useEffect, useState } from 'react';
import { ContractWizardInfos } from '../../../../composition/wizard-infos/contract.wizard-infos';
import { ContractBaseForm } from '../../../../form/contract-create/contract-create.form';
import { CreateNewSingleContractWizardContext } from '../../createNewSingleContract.wizard';

export const ContractStep = ({
  context: { contractBase, product },
  validate,
  submit,
}: WizardItemType.Config.Component<CreateNewSingleContractWizardContext>) => {
  const { t, lang } = useTranslation();

  const [instance, setInstance] = useState<
    FormType.HandleEvent.Instance['value1'] | null
  >(null);

  useEffect(() => {
    if (instance) {
      instance.validateFields({
        validateOnly: true,
        dirty: false,
        recursive: true,
      });
    }
  }, [instance]);

  return (
    <Form
      data={{ value: contractBase }}
      config={{ validateOnChange: true }}
      handleEvent={{
        change: (value: any) => {
          let contractFormatted = value;
          const endDate = DateTime.fromISO(value.startDate);

          if (value.startDate && product.period) {
            contractFormatted = {
              ...contractFormatted,
              endDate:
                product.duration?.durationUnit &&
                product.duration?.durationValue
                  ? endDate
                      .plus(
                        product.duration.durationUnit === 'HOUR'
                          ? { hours: product.duration.durationValue }
                          : product.duration.durationUnit === 'MONTH'
                            ? { months: product.duration.durationValue }
                            : { years: product.duration.durationValue },
                      )
                      .minus({ day: 1 })
                      .toISO()
                  : endDate.toISO(),
            };
          }

          if (contractFormatted.APBMode === 'NONE') {
            contractFormatted = {
              ...contractFormatted,
              APBNext: null,
            };
          } else if (
            contractFormatted.APBMode !== 'NONE' &&
            [null, undefined].includes(contractFormatted.APBNext)
          ) {
            contractFormatted = {
              ...contractFormatted,
              APBNext: true,
            };
          }

          submit({
            contractBase: contractFormatted,
          });
        },
        validate: (value: boolean) => {
          console.log('🚀 ~ value:', value);
          validate(value);
        },
        instance: (form) => {
          setInstance(form);
        },
      }}
    >
      <Zone
        config={{
          gap: {
            y: 1,
            x: 1,
          },
          zones: [['info', 'form']],
          rows: ['1fr'],
          columns: ['min-content', '1fr'],
        }}
      >
        <Zone.Area config={{ area: 'info' }}>
          <ContractWizardInfos
            data={{
              productName: product.id ? t(`product-${product.id}-name`) : null,
              APBMode: contractBase.APBMode,
              APBNext:
                contractBase.APBMode !== 'NONE' ? contractBase.APBNext : null,
              state: contractBase.state,
              startDate: contractBase.startDate,
              endDate: contractBase.endDate,
              description: contractBase.description,
              reference: contractBase.reference,
              articleCode: contractBase.articleCode,
            }}
          />
        </Zone.Area>

        <Zone.Area config={{ area: 'form' }}>
          {contractBase.articleCode && (
            <ContractBaseForm
              data={{
                contract: contractBase,
              }}
              config={{
                disabled: {
                  endDate: typeof product.period === 'number',
                },
                articleCodes: product.articleCodes,
              }}
            />
          )}
        </Zone.Area>
      </Zone>
    </Form>
  );
};
